import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { getDeclarationHistory } from '../../apiCalls';
import DataTable from '../../DataTable';
import DeclarationsActionsButton from '../DeclarationsActionsButton/DeclarationsActionsButton';
import { formatUkDateFromString } from '../../../utils/stringUtils';

const DEC_TYPES = {
  10: 'SFD',
  20: 'SDI',
};

const DeclarationsHistory = () => {
  const { loadId, portalId } = useParams();
  const navigate = useNavigate();
  const [portalRef, setPortalRef] = useState('');
  const [historyTableValues, setHistoryTableValues] = useState([]);
  const [declarationType, setDeclarationType] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const response = await getDeclarationHistory(loadId, portalId);

      const items = response?.items || [];
      const tableValues = items.map(
        ({
          id,
          lrn,
          mrn,
          declarationtype: declarationType,
          declarationstatus: declarationStatus,
          dmsacc_date,
          dmsrcv_date,
          dmscle_date,
          dmsrej_date,
          dmsinv_date,
        }) => {
          return {
            id,
            lrn,
            mrn,
            declarationType,
            declarationStatus,
            dmsacc: formatUkDateFromString(dmsacc_date),
            dmsrcv: formatUkDateFromString(dmsrcv_date),
            dmscle: formatUkDateFromString(dmscle_date),
            dmsrej: formatUkDateFromString(dmsrej_date),
            dmsinv: formatUkDateFromString(dmsinv_date),
            actions: <DeclarationsActionsButton id={id} />,
          };
        }
      );

      const lrn = JSON.parse(response.header)?.LRN;

      setPortalRef(lrn);
      setHistoryTableValues(tableValues);
      setDeclarationType(DEC_TYPES[tableValues[0]?.declarationType] || '');

      setLoading(false);
    };

    fetchData();
  }, [loadId, portalId]);

  return (
    <div className="full-width-container declarations-actions">
      <section className="floating-box position-relative p-3" style={{ maxWidth: '1040px' }}>
        <div className="d-flex justify-content-between">
          <h1 className="pb-2">{portalRef}</h1>
          <h2 className="pe-5">{declarationType}</h2>
        </div>

        <div className="pb-4">
          <DataTable
            dontRefreshPagination
            idKey="id"
            data={historyTableValues}
            className="table-striped"
            lazyLoading
            isLoading={loading}
          >
            <DataTable.Column colKey="lrn" header="LRN" />
            <DataTable.Column colKey="mrn" header="MRN" />
            <DataTable.Column colKey="declarationStatus" header="STATUS" />
            <DataTable.Column colKey="dmsrcv" header="DMSRCV" />
            <DataTable.Column colKey="dmsacc" header="DMSACC" />
            <DataTable.Column colKey="dmscle" header="DMSCLE" />
            <DataTable.Column colKey="dmsrej" header="DMSREJ" />
            <DataTable.Column colKey="dmsinv" header="DMSINV" />
            <DataTable.Column header="Actions">
              {(item) => <DeclarationsActionsButton id={item.id} portalId={portalId} loadId={loadId} />}
            </DataTable.Column>
          </DataTable>
        </div>

        <Button variant="secondary" className="mt-4 align-self-end input-inner-container" onClick={() => navigate(-1)}>
          Back
        </Button>
      </section>
    </div>
  );
};

export default DeclarationsHistory;
